import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";

export async function authenticateAdmin(
  apiClient: ApiClient,
  input: Schemas["AuthenticateAdminRequest"],
  signal?: AbortSignal,
): Promise<Schemas["AuthenticateAdminResponse"]> {
  const response = await apiClient.post<
    Schemas["AuthenticateAdminResponse"],
    Schemas["AuthenticateAdminRequest"]
  >("/api/v1/admin/auth/login", input, { signal });
  return response.data;
}

export async function changeAdminPassword(
  apiClient: ApiClient,
  input: Schemas["ChangeAdminPasswordRequest"],
  signal?: AbortSignal,
): Promise<Schemas["AuthenticateAdminResponse"]> {
  const response = await apiClient.post<Schemas["AuthenticateAdminResponse"], Schemas["ChangeAdminPasswordRequest"]>(
    "/api/v1/admin/auth/password/change",
    input,
    { signal },
  );
  return response.data;
}

export async function beginAdminTotpEnrollment(
  apiClient: ApiClient,
  signal?: AbortSignal,
): Promise<Schemas["AdminTotpEnrollmentResponse"]> {
  const response = await apiClient.post<Schemas["AdminTotpEnrollmentResponse"]>(
    "/api/v1/admin/auth/totp/enrollment",
    undefined,
    { signal },
  );
  return response.data;
}

export async function confirmAdminTotpEnrollment(
  apiClient: ApiClient,
  input: Schemas["ConfirmAdminTotpRequest"],
  signal?: AbortSignal,
): Promise<Schemas["AdminTotpConfirmationResponse"]> {
  const response = await apiClient.post<
    Schemas["AdminTotpConfirmationResponse"],
    Schemas["ConfirmAdminTotpRequest"]
  >("/api/v1/admin/auth/totp/enrollment/confirm", input, { signal });
  return response.data;
}
